import(/* webpackMode: "eager" */ "/var/www/checkin/frontend/app/worker-portal/page.tsx");
